module.exports = __webpack_public_path__ + "static/media/11_plantilla_menu_comida_15.930d8877.png";